import logo from './logo.svg';
import './App.css';
import {TextField, Button, Typography} from '@mui/material';
import { Box, Container, Stack } from '@mui/system';
import Lottie from "lottie-react";
import submitAnimation from "./form-submission.json";
import {useState} from 'react'



function App() {
  const [submitted,setSubmitted] = useState(false);

  return (
    <div className="App">
      {submitted ? <Lottie animationData={submitAnimation} loop={false} style={{width:'50%'}}/> : 
      <div> 
      <Typography>
      <Typography variant='h4'>
        100 Cards
      </Typography>
      <Typography variant='button'>
        Support service
      </Typography>
      </Typography>
      <Stack spacing={2} sx={{alignItems:'center'}}>
      <TextField sx={{maxWidth:300}} id="outlined-basic" label="Your email" variant="outlined" />
      <TextField  sx={{maxWidth:300}} id="outlined-basic" label="Question" variant="outlined" />
      </Stack>
      <Button onClick={() => setSubmitted(true)} variant="contained" sx={{mt:2}}>Submit</Button>
      </div>}
    </div>
  );
}

export default App;
